<template>
    <div class="outall">
      <div>
        <div class="tp1">
            <div>
              <b-img :src="require('@/assets/banner04_1new_720.png')" class="tp1-image" />
            </div>             
        </div>

        <div class="tp2">
          <div class="tp2_left"></div>
          <div class="tp2_mid">
            <div class="tp2_mid_left">
              <div class="tp2_mid_left_1">
                <div class="tp2_mid_left_1_image"><b-img :src="require('@/assets/newout_p4.svg')" class="tp2-image1" /></div>
                <div class="tp2_mid_left_1_d">
                  <div class="tp2_mid_left_1_title">Dedicate More Time To Patient Care</div>
                  <div class="tp2_mid_left_1_sub">Streamline your workflows to enable more productive and focused patient care,significantly reduce manual paperwork, and enhance overall operations</div>
                </div>
              </div>
              <div class="tp2_mid_left_2">
                <div class="tp2_mid_left_2_image"><b-img :src="require('@/assets/newout_p4.svg')" class="tp2-image1" /></div>
                <div class="tp2_mid_left_2_d">
                  <div class="tp2_mid_left_2_title">Customized For Singapore</div>
                  <div class="tp2_mid_left_2_sub">Our platform is crafted specifically for Singapore, incorporating feedback from healthcare practitioners across the country. We've listened to every word you said.</div>
                </div>
              </div>
              <div class="tp2_mid_left_3">
                <div class="tp2_mid_left_3_image"><b-img :src="require('@/assets/newout_p4.svg')" class="tp2-image1" /></div>
                <div class="tp2_mid_left_3_d">
                  <div class="tp2_mid_left_3_title">Secure and Private</div>
                  <div class="tp2_mid_left_3_sub">Our platform meets rigorous cybersecurity protocols and PDPA regulations to protect your data and privacy</div>
                </div>
              </div>
            </div>
            <div class="tp2_mid_right"><b-img :src="require('@/assets/newout_p2.svg')" class="tp2-image2" /></div>
          </div>
          <div class="tp2_right"></div>
        </div>

        <div class="tp3">
          <div class="tp3_left"></div>
          <div class="tp3_mid">
            <div class="tp3_1">Advanced Features</div>
          </div>
          <div class="tp3_right"></div>
        </div>

        <div class="tp4">
          <div class="tp4_left"></div>
          <div class="tp4_mid">
            <div class="tp4_mid_left"><b-img :src="require('@/assets/newout_p5.svg')" class="tp4-image1" /></div>
            <div class="tp4_mid_right">
              <div class="tp4_mid_right_1">
                <div class="tp4_mid_right_1_title">Manage Your Team</div>
                <div class="tp4_mid_right_1_sub">Assign patients to your team members so you will always know their status, ensuring efficient coordination and optimal care delivery.</div>
              </div>
              <div class="tp4_mid_right_2">
                <div class="tp4_mid_right_2_title">Manage Your Patients</div>
                <div class="tp4_mid_right_2_sub">Gain a comprehensive overview of each patient's progress, with detailed data and trend analysis, to offer personalized care.</div>
              </div>
            </div>
          </div>
          <div class="tp4_right"></div>
        </div>

        <div class="tp5">
          <div class="tp5_left"></div>
          <div class="tp5_mid">
            <div class="tp5_mid_left">
              <div class="tp5_mid_left_title">Information You Need For Customized Patient Care</div>
              <div class="tp5_mid_left_sub">
                <div class="tp5_mid_left_sub_1">
                  <div class="tp5_mid_left_sub_1_image"><b-img :src="require('@/assets/newout_p6.svg')" class="tp5-image1" /></div>
                  <div class="tp5_mid_left_sub_1_d">Blood Glucose Reading</div>
                </div>
                <div class="tp5_mid_left_sub_2">
                  <div class="tp5_mid_left_sub_2_image"><b-img :src="require('@/assets/newout_p7.svg')" class="tp5-image2" /></div>
                  <div class="tp5_mid_left_sub_2_d">Weight</div>
                </div>
                <div class="tp5_mid_left_sub_3">
                  <div class="tp5_mid_left_sub_3_image"><b-img :src="require('@/assets/newout_p8.svg')" class="tp5-image3" /></div>
                  <div class="tp5_mid_left_sub_3_d">Blood Pressure</div>
                </div>
                <div class="tp5_mid_left_sub_4">
                  <div class="tp5_mid_left_sub_4_image"><b-img :src="require('@/assets/newout_p9.svg')" class="tp5-image4" /></div>
                  <div class="tp5_mid_left_sub_4_d">Meal Photos</div>
                </div>
              </div>
            </div>
            <div class="tp5_mid_right"><b-img :src="require('@/assets/newout_p10.svg')" class="tp5-image6" /></div>
          </div>
          <div class="tp5_right"></div>
        </div>

        <div class="tp6">
          <div class="tp6_left"></div>
          <div class="tp6_mid">
            <div class="tp6_mid_left">
              <div class="tp6_mid_left_1"><b-img :src="require('@/assets/newout_p11.svg')" class="tp6-image1" /></div>
              <div class="tp6_mid_left_2">
                <div class="tp6_mid_left_2_mainimage"><b-img :src="require('@/assets/newout_p12.svg')" class="tp6-image2" /></div>
                <div class="tp6_mid_left_2_title">Download App</div>
                <div class="tp6_mid_left_2_qrcode">
                  <div class="tp6_mid_left_2_qrcode_left">
                    <div class="tp6_mid_left_2_qrcode_left_1"><b-img :src="require('@/assets/newout_p13.svg')" class="tp6-image3" /></div>
                    <div class="tp6_mid_left_2_qrcode_left_2"><b-img :src="require('@/assets/newout_p14.svg')" class="tp6-image4" /></div>
                  </div>
                  <div class="tp6_mid_left_2_qrcode_right">
                    <div class="tp6_mid_left_2_qrcode_right_1"><b-img :src="require('@/assets/newout_p15.svg')" class="tp6-image5" /></div>
                    <div class="tp6_mid_left_2_qrcode_right_2"><b-img :src="require('@/assets/newout_p16.svg')" class="tp6-image6" /></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tp6_mid_right">
              <div class="tp6_mid_right_title">Preparing For The Future</div>
              <div class="tp6_mid_right_d1">
                <div class="tp6_mid_right_d1_title">Remote Data Viewing</div>
                <div class="tp6_mid_right_d1_sub">Remote data viewing - Access patient data remotely so patients don't even need to come into the clinic, enhancing patient care and reducing unnecessary visits.</div>
              </div>
              <div class="tp6_mid_right_d2">
                <div class="tp6_mid_right_d2_title">Convenient PDF Reports</div>
                <div class="tp6_mid_right_d2_sub">Easily view remote patient reports in PDF format, allowing for seamless and efficient remote patient monitoring and documentation.</div>
              </div>
              <div class="tp6_mid_right_d3">
                <div class="knowmorebutton">
                  <div class="tp6_mid_right_d3_button">
                <b-button variant="primary" to="/OnCallCareApp" target="_blank" style="width: 243px;">
                  <div class="txtb2" style="margin-left: -28px;">Learn more about APP</div>
                </b-button>
                    <div class="jiantou">
                      <b-img  fluid :src="require('@/assets/jiantou.png')" class="jiantou1"></b-img>
                    </div>
              </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tp6_right"></div>
        </div>

        <div class="tp6_cgm">
          <div class="tp6_cgm_left"></div>
          <div class="tp6_cgm_mid">
            <div class="tp6_cgm_mid_text">
              <div class="tp6_cgm_section">
                <div class="tp6_cgm_section_title">Product Functions</div>
                <div class="tp6_cgm_section_item">
                  <div class="tp6_cgm_bullet"><b-img :src="require('@/assets/inhos_p8.png')" class="tp6_cgm_bullet_img" /></div>
                  <div class="tp6_cgm_section_item_text">Connect to CGM devices via Bluetooth to display real-time current glucose values and generate monitoring charts that reflect glucose trends.</div>
                </div>
                <div class="tp6_cgm_section_item">
                  <div class="tp6_cgm_bullet"><b-img :src="require('@/assets/inhos_p8.png')" class="tp6_cgm_bullet_img" /></div>
                  <div class="tp6_cgm_section_item_text">Provide high/low blood glucose alerts to help users respond to risks in a timely manner.</div>
                </div>
              </div>
              <div class="tp6_cgm_section">
                <div class="tp6_cgm_section_title">Usage Scenarios</div>
                <div class="tp6_cgm_section_item">
                  <div class="tp6_cgm_bullet"><b-img :src="require('@/assets/inhos_p8.png')" class="tp6_cgm_bullet_img" /></div>
                  <div class="tp6_cgm_section_item_text">Home self-management</div>
                </div>
                <div class="tp6_cgm_section_item">
                  <div class="tp6_cgm_bullet"><b-img :src="require('@/assets/inhos_p8.png')" class="tp6_cgm_bullet_img" /></div>
                  <div class="tp6_cgm_section_item_text">Diet and exercise management</div>
                </div>
              </div>
              <div class="tp6_cgm_section">
                <div class="tp6_cgm_section_title">Supporting Equipment</div>
                <div class="tp6_cgm_section_item">
                  <div class="tp6_cgm_bullet"><b-img :src="require('@/assets/inhos_p8.png')" class="tp6_cgm_bullet_img" /></div>
                  <div class="tp6_cgm_section_item_text">Disposable sensor: Worn on the upper arm and can be used continuously for up to 14 days.</div>
                </div>
                <div class="tp6_cgm_section_item">
                  <div class="tp6_cgm_bullet"><b-img :src="require('@/assets/inhos_p8.png')" class="tp6_cgm_bullet_img" /></div>
                  <div class="tp6_cgm_section_item_text">Signal transmitter: Connects to the sensor and transmits data via Bluetooth.</div>
                </div>
                <div class="tp6_cgm_section_item">
                  <div class="tp6_cgm_bullet"><b-img :src="require('@/assets/inhos_p8.png')" class="tp6_cgm_bullet_img" /></div>
                  <div class="tp6_cgm_section_item_text">Mobile App: Acts as a receiver to display data and send alerts.</div>
                </div>
              </div>
            </div>
            <div class="tp6_cgm_mid_download">
              <div class="tp6_mid_left_2_mainimage"><b-img :src="require('@/assets/cgmItems.png')" class="tp6-image2" /></div>
              <div class="tp6_cgm_download_title">Download App</div>
              <div class="tp6_cgm_qrcode">
                <div class="tp6_cgm_qrcode_left">
                  <div class="tp6_cgm_qrcode_left_1"><b-img :src="require('@/assets/cgm-ios.png')" class="tp6_cgm_qrcode_img" /></div>
                  <div class="tp6_cgm_qrcode_left_2"><b-img :src="require('@/assets/newout_p14.svg')" class="tp6_cgm_store_badge" /></div>
                </div>
                <div class="tp6_cgm_qrcode_right">
                  <div class="tp6_cgm_qrcode_right_1"><b-img :src="require('@/assets/cgm-android.png')" class="tp6_cgm_qrcode_img" /></div>
                  <div class="tp6_cgm_qrcode_right_2"><b-img :src="require('@/assets/newout_p16.svg')" class="tp6_cgm_store_badge" /></div>
                </div>
              </div>
            </div>
            <div class="tp6_cgm_mid_phone">
              <b-img :src="require('@/assets/cgmItems2.png')" class="tp6_cgm_phone_img" />
            </div>
          </div>
          <div class="tp6_cgm_right"></div>
        </div>

        <div class="tp7">
            <div class="tp7_1">Supporting Devices</div>
            <div class="tp7_1_sub">Multiple Devices Are Used For Blood Collection, And Data Is Transmitted To The APP Through Sure Sync</div>
        </div>

        <div class="tp8">
          <div class="tp8_left"></div>
          <div class="tp8_mid" style="display: flex;">
            <div class="tp8_mid_1" style="width: 342px; margin-right: 64px;">
              <div class="tp8_mid_1_1">
                <div style="margin-bottom: 16px;">
                  <b-img :src="require('@/assets/outhostp8_1.png')" class="tp8-image" />
                </div>  
              </div>
              <div class="tp8_mid_1_2">On Call Sure Sync Blood Glucose Monitoring System</div>
              <div class="tp8_mid_1_3">
                <div class="tp8_mid_1_3_1" style="display: flex;">
                  <div class="tp8_mid_1_3_1_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_1_3_1_txt" style="display: flex;">GDH-FAD Enzyme <div class="space" style="margin-left: 80px;">No-coding</div></div>
                </div>
                <div class="tp8_mid_1_3_2" style="display: flex;">
                  <div class="tp8_mid_1_3_2_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_1_3_2_txt" style="display: flex;">10-70% HCT Range <div style="margin-left: 70px;">5s Testing Time</div></div>
                </div>
                <div class="tp8_mid_1_3_3" style="display: flex;">
                  <div class="tp8_mid_1_3_3_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_1_3_3_txt">0.6μL Capillary/Venous/Arterial/Neonatal</div>
                </div>
                <div class="tp8_mid_1_3_4" style="display: flex;">
                  <div class="tp8_mid_1_3_4_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_1_3_4_txt" style="display: flex;">Sample <div style="margin-left: 160px;">510(k) & CE</div></div>
                </div>
              </div>
            </div>
            <div class="tp8_mid_2" style="width: 381px; margin-right: 64px;">
              <div class="tp8_mid_2_1">
                <div style="margin-bottom: 16px;">
                  <b-img :src="require('@/assets/outhostp8_2.png')" class="tp8-image" />
                </div>  
              </div>
              <div class="tp8_mid_2_2">On Call Lancet Device</div>
              <div class="tp8_mid_2_3">
                <div class="tp8_mid_2_3_1" style="display: flex;">
                  <div class="icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_2_3_1_sub">Adjustable Penetration Depth</div>
                </div>
                <div class="tp8_mid_2_3_2" style="display: flex;">
                  <div class="icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_2_3_2_sub">Ergonomically designed for one hand operation</div>
                </div>
                <div class="tp8_mid_2_3_3" style="display: flex;">
                  <div class="icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_2_3_3_sub">Improved comfort for easy blood sample collection</div>
                </div>
                <div class="tp8_mid_2_3_4" style="display: flex;">
                  <div class="icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_2_3_4_sub">Built-in ejector for safe and easy testing</div>
                </div>
                <div class="tp8_mid_2_3_5" style="display: flex;">
                  <div class="icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_2_3_5_sub">Color safety indicator to show lancet is loaded</div>
                </div>
              </div>
            </div>
            <div class="tp8_mid_3" style="width: 342px;">
              <div class="tp8_mid_3_1">
                <div style="margin-bottom: 16px;">
                  <b-img :src="require('@/assets/outhostp8_3.png')" class="tp8-image" />
                </div>  
              </div>
              <div class="tp8_mid_3_2">On Call Safety Lancets</div>
              <div class="tp8_mid_3_3">
                <div class="tp8_mid_3_3_1" style="display: flex;">
                  <div class="icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_3_3_1_sub">Quick and convenient for capillary blood sampling Easy to use</div>
                </div>
                <div class="tp8_mid_3_3_2" style="display: flex;">
                  <div class="icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="tp8_mid_3_3_2_sub">No loading or lancing device required Needless automatically retract for safety</div>
                </div>
              </div>
            </div>
          </div>
          <div class="tp8_right"></div>
        </div>

      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'OutHospitalPage',
    mounted() {
  },
  }
  </script>
  
  <style scoped>
  .outall{
    min-width: 1200px;
  }
 .tp1_img{
  width: 4px;
  height: 4px;
  margin-right: 8px;
 }
.tp1{
  position: relative;
  width: 100%;
  overflow: hidden;
}
.tp1-image{
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dis1{
  font-family: Arial;
font-size: 120px;
font-weight: 700;
line-height: 140px;
margin-top: 478px;
margin-bottom: 200px;
margin-left: 15.75%;
width: 1336px;
z-index: 99;
color: #007EFF;
}
.highlight{
  color: #ffffff;
}


.tp2 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; 
  gap: 0; 

}

.tp2_mid {
  display: grid;
  grid-template-columns: 594px auto; 
  gap: 0; 
  align-items: center; 
}

.tp2_mid_left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 子元素在垂直方向上对齐起始位置 */
  padding: 20px; 
}

.tp2_mid_left_1,
.tp2_mid_left_2,
.tp2_mid_left_3 {
  display: flex;
  gap: 10px; /* 子元素之间的间距 */
  margin-bottom: 20px; /* 每个块之间的间距 */
}

.tp2_mid_left_1_image,
.tp2_mid_left_2_image,
.tp2_mid_left_3_image {
  width: 0px; /* 图片宽度 */
}

.tp2_mid_left_1_d,
.tp2_mid_left_2_d,
.tp2_mid_left_3_d {
  flex: 1;
}

.tp2_mid_left_1_title,
.tp2_mid_left_2_title,
.tp2_mid_left_3_title {
  font-family: Arial;
font-size: 24px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #000000;
margin-bottom: 8px;
}

.tp2_mid_left_1_sub,
.tp2_mid_left_2_sub,
.tp2_mid_left_3_sub {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
text-align: left;
color: #555555;
margin-bottom: 40px;
}


.tp2_mid_right {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px; /* 添加内边距 */
  margin-top: -40px;
}

.tp2-image1 {
  width: 100%;
  height: auto;
}

.tp2-image2 {
  width: 100%; /* 图像宽度 */
  height: auto; /* 图像高度 */
  object-fit: cover; /* 确保图片按比例填充 */
}

.tp3 {
  display: grid;
  grid-template-columns: 1fr 684px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
  align-items: center; /* 子元素垂直居中 */
  margin-top: -20px;
}

.tp3_mid {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px; 
  /*background-color: #007EFF;
  border-radius: 80px;*/
}

.tp3_1 {
  color: #000000; 
  text-align: center; 
  font-family: Arial;
font-size: 36px;
font-weight: 700;
line-height: 44px;
}

.tp4 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; 
  gap: 0; 
margin-top: 40px;
}

.tp4_mid {
  display: grid;
  grid-template-columns: 700px 500px; /* 将中间部分划分为两列，左边700px，右边500px */
  gap: 0; /* 去掉列间距 */
  align-items: center; /* 子元素在垂直方向上居中对齐 */
}

.tp4_mid_left {
  display: flex;
  align-items: center;
  justify-content: center;

}

.tp4-image1 {
  width: 100%; /* 图像宽度 */
  height: auto; /* 图像高度 */
}

.tp4_mid_right {
  padding: 20px; /* 添加内边距 */
}

.tp4_mid_right_1,
.tp4_mid_right_2 {
  margin-bottom: 20px; /* 每个块之间的间距 */
}

.tp4_mid_right_1_title,
.tp4_mid_right_2_title {
  font-family: Arial;
font-size: 24px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #000000;
margin-bottom: 8px;
}

.tp4_mid_right_1_sub,
.tp4_mid_right_2_sub {
  font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 26px;
text-align: left;
color: #555555;
}
.tp4_mid_right_1_sub{
  margin-bottom: 64px;
}

.tp5 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
  margin-top: 20px;
}
.tp5_mid {
  display: grid;
  grid-template-columns: 500px 700px; /* 将中间部分划分为两列，左边500px，右边700px */
  gap: 0; /* 去掉列间距 */
  align-items: center; /* 子元素在垂直方向上居中对齐 */
}

.tp5_mid_left {
padding: 20px;
}

.tp5_mid_left_title {
  font-family: Arial;
font-size: 24px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #000000;
  margin-bottom: 40px; /* 标题和内容之间的间距 */
}

.tp5_mid_left_sub {
  display: flex;
  flex-direction: column;
  gap: 20px; /* 子元素之间的间距 */
}

.tp5_mid_left_sub_1,
.tp5_mid_left_sub_2,
.tp5_mid_left_sub_3,
.tp5_mid_left_sub_4 {
  display: flex;
  align-items: center;
}

.tp5_mid_left_sub_1_image,
.tp5_mid_left_sub_2_image,
.tp5_mid_left_sub_3_image,
.tp5_mid_left_sub_4_image {
  margin-right: 16px; /* 图片和文字之间的间距 */
}

.tp5_mid_left_sub_1_d,
.tp5_mid_left_sub_2_d,
.tp5_mid_left_sub_3_d,
.tp5_mid_left_sub_4_d {
  font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 26px;
text-align: left;
color: #333333;
}

.tp5_mid_right {
  display: flex;
  align-items: center;
  justify-content: center;

}

.tp5-image1,
.tp5-image2,
.tp5-image3,
.tp5-image4,
.tp5-image6 {
  width: 100%; /* 图像宽度 */
  height: auto; /* 图像高度 */
}

.tp6 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */

}

.tp6_mid {
  display: grid;
  grid-template-columns: 700px 500px; /* 将中间部分划分为两列，左边700px，右边500px */
  gap: 0; /* 去掉列间距 */
  align-items: center; /* 子元素在垂直方向上居中对齐 */
}

.tp6_mid_left {
  padding: 20px; /* 添加内边距 */
      align-content: center;
    justify-content: center;
    align-items: center;
    display: flex;
}

.tp6_mid_left_1,
.tp6_mid_left_2 {
  margin-bottom: 20px; /* 每个块之间的间距 */
}

.tp6_mid_left_2 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tp6_mid_left_2_qrcode {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.tp6_mid_left_2_qrcode_left,
.tp6_mid_left_2_qrcode_right {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tp6_mid_left_2_title {
  font-size: 1.2em;
  font-weight: bold;
  text-align: left; /* 文本靠左对齐 */
  margin-top: 10px;
  margin-bottom: 10px;
}

.tp6_mid_right {
  padding: 20px; /* 添加内边距 */
}

.tp6_mid_right_title {
  font-family: Arial;
font-size: 28px;
font-weight: 700;
line-height: 36px;
text-align: left;
color: #000000;
  margin-bottom: 34px; /* 标题和内容之间的间距 */
}

.tp6_mid_right_d1,
.tp6_mid_right_d2 {
  margin-bottom: 20px; /* 每个块之间的间距 */
}

.tp6_mid_right_d1_title,
.tp6_mid_right_d2_title {
  font-family: Arial;
font-size: 24px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #000000;
margin-bottom: 8px;
}

.tp6_mid_right_d1_sub,
.tp6_mid_right_d2_sub {
  font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 26px;
text-align: left;
color: #555555;
}

.tp6-image1,
.tp6-image2,
.tp6-image3,
.tp6-image4,
.tp6-image5,
.tp6-image6 {
  width: 100%; /* 图像宽度 */
  height: auto; /* 图像高度 */
}
.tp6_mid_left_2_qrcode_right_2{
  margin-top: -32px;
}
.jiantou{
  margin-left: -30px;
  margin-top: 5px;
}
.tp6_mid_right_d3_button {
  display: flex;
  margin-top: 8%;
}

.tp6_cgm {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr;
  gap: 0;
  margin-top: 80px;
  margin-bottom: 80px;
}

.tp6_cgm_mid {
  display: grid;
  grid-template-columns: 500px 200px 500px;
  gap: 0;
  align-items: center;
}

.tp6_cgm_mid_text {
  padding: 20px;
}

.tp6_cgm_section {
  margin-bottom: 32px;
}

.tp6_cgm_section:last-child {
  margin-bottom: 0;
}

.tp6_cgm_section_title {
  font-family: Arial;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  text-align: left;
  color: #000000;
  margin-bottom: 12px;
}

.tp6_cgm_section_item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.tp6_cgm_bullet {
  flex-shrink: 0;
  align-self: flex-start;
  margin-right: 8px;
  padding-top: 11px;
  line-height: 0;
}

.tp6_cgm_bullet_img {
  width: 4px;
  height: 4px;
  display: block;
}

.tp6_cgm_section_item_text {
  font-family: Arial;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  color: #555555;
}

.tp6_cgm_mid_download {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.tp6_cgm_download_title {
  font-size: 1.2em;
  font-weight: bold;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
}

.tp6_cgm_qrcode {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.tp6_cgm_qrcode_left,
.tp6_cgm_qrcode_right {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tp6_cgm_qrcode_img,
.tp6_cgm_store_badge {
  width: 100%;
  height: auto;
}

.tp6_cgm_qrcode_right_2 {
  margin-top: -32px;
}

.tp6_cgm_mid_phone {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.tp6_cgm_phone_img {
  width: 100%;
  height: auto;
}

.tp7 {
  align-items: center; /* 子元素垂直居中 */
}
.tp7_mid {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.tp7_1 {
  font-family: Arial;
font-size: 36px;
font-weight: 700;
line-height: 44px;
text-align: center;
margin-bottom: 8px;
}
.tp7_1_sub {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
text-align: center;
margin-bottom: 80px;
}

.tp8 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
  margin-bottom: 211px;
}
.tp8_mid {
  display: grid;
  grid-template-columns: 400px 400px 400px; 
  gap: 0; /* 去掉列间距 */
  justify-content: flex-start;
  align-items: flex-start;
}
.tp8_mid_2_3_1_sub, 
.tp8_mid_2_3_2_sub, 
.tp8_mid_2_3_3_sub,
.tp8_mid_2_3_4_sub,
.tp8_mid_2_3_5_sub,
.tp8_mid_3_3_1_sub,
.tp8_mid_3_3_2_sub,
.tp8_mid_1_3_1_txt,
.tp8_mid_1_3_2_txt,
.tp8_mid_1_3_3_txt,
.tp8_mid_1_3_4_txt {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 26px;
text-align: left;
color: #555555;
margin-bottom: 4px;
}
.tp8_mid_1_2, 
.tp8_mid_2_2, 
.tp8_mid_3_2 {
  font-family: Arial;
font-size: 20px;
font-weight: 400;
line-height: 28px;
text-align: left;
margin-bottom: 16px;
color: #000000;
}
  </style>